// components/LandingPageSection6.jsx
import React from "react";
import styles from "./LandingPageSection6.module.css";

import card1 from "../../../../Images/newLandingPage/61.png";
import card2 from "../../../../Images/newLandingPage/62.png";
import card3 from "../../../../Images/newLandingPage/63.png";


import scaleImage from "../../../../Images/newLandingPage/247.png";
const LandingPageSection6 = () => {
  return (
    <>
      {/* Effortless Setup Section */}
      <section className={styles.effortlessSection}>
        <div className={styles.container}>
          <h2 className={styles.title}>Effortless Setup</h2>
          <div className={styles.cards}>
            <div className={styles.card}>
              <div className={styles.iconWrapper}>
                <img
                  src={card1}
                  alt="Instant Access"
                  className={styles.icon}
                />
              </div>
              <h3>Instant Access</h3>
              <p>
                Sign in, connect your business account, and start instantly, no
                complex setup.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.iconWrapper}>
                <img
                  src={card2}
                  alt="Customize Agent"
                  className={styles.icon}
                />
              </div>
              <h3>Customize Your AI Agent</h3>
              <p>
                Pick a template or build your own using a simple drag-and-drop
                editor.
              </p>
            </div>

            <div className={styles.card}>
              <div className={styles.iconWrapper}>
                <img
                  src={card3}
                  alt="Launch Immediately"
                  className={styles.icon}
                />
              </div>
              <h3>Launch Immediately</h3>
              <p>
                Activate with one click. Your AI starts taking calls and capturing
                leads right away.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Ready to Scale Section */}
      <section className={styles.scaleSection}>
        <div className={styles.container}>
          <div className={styles.contentWrapper}>
            <div className={styles.textSide}>
              <h2 className={styles.scaleTitle}>
                Ready to Scale Beyond <br />
                <span className={styles.highlight}>10,000+ Call Minutes a Month?</span>
              </h2>
              <p className={styles.description}>
                Eliminate bottlenecks. Let AI handle repetitive calls, log every lead,
                and update your CRM.
              </p>
              <ul className={styles.benefits}>
                <li>Your customers get faster responses.</li>
                <li>Your team saves hours.</li>
                <li>You get ROI 24/7.</li>
              </ul>
              <button className={styles.ctaButton}>
                Contact Sales <span className={styles.arrow}>→</span>
              </button>
            </div>
            <div className={styles.imageSide}>
              <img
                src={scaleImage}
                alt="Scale Beyond 10,000+ Minutes"
                className={styles.scaleImage}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LandingPageSection6;